/******************************************************************************
 * Copyright (c) 2026 Contributors to the Eclipse Foundation.
 *
 * See the NOTICE file(s) distributed with this work for additional
 * information regarding copyright ownership.
 *
 * This program and the accompanying materials are made available under the
 * terms of the Eclipse Public License 2.0 which is available at
 * https://www.eclipse.org/legal/epl-2.0.
 *
 * SPDX-License-Identifier: EPL-2.0
 *****************************************************************************/

import { useQuery } from '@tanstack/react-query';
import { sendRequest } from 'openvsx-webui';

interface Project {
  project_id: string;
  name: string;
  url: string;
  logo: string;
  adopters: Adopter[];
}

interface Adopter {
  name: string;
  logo: string;
  projects: string[];
  homepage_url: string;
  logo_white: string;
}

/** The adopters of Open VSX, from the Eclipse adopters API; empty when the project is not listed. */
export const useAdopters = () =>
  useQuery({
    queryKey: ['adopters'],
    queryFn: async ({ signal }) => {
      const projects = await sendRequest<Project[]>({
        signal,
        endpoint: 'https://api.eclipse.org/adopters/projects?working_group=cloud-development-tools'
      });
      return projects.find((project) => project.project_id === 'ecd.openvsx')?.adopters ?? [];
    }
  });
